var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.316 5.24134C10.0939 3.22826 8.49604 1.63035 6.48296 1.40829V0.413818H5.51746V1.40829C3.50439 1.63035 1.90648 3.22826 1.68441 5.24134H0.689941V6.20684H1.68441C1.90648 8.21992 3.50439 9.81783 5.51746 10.0399V11.0344H6.48296V10.0399C8.49604 9.81783 10.0939 8.21992 10.316 6.20684H11.3105V5.24134H10.316ZM6.00021 9.10335C4.13196 9.10335 2.62095 7.59234 2.62095 5.72409C2.62095 3.85584 4.13196 2.34483 6.00021 2.34483C7.86846 2.34483 9.37948 3.85584 9.37948 5.72409C9.37948 7.59234 7.86846 9.10335 6.00021 9.10335Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6f57f8cfb4cecba97d536b101c441854.svg";
export { ForwardRef as ReactComponent };